import { datadogRum } from '@datadog/browser-rum';
import { getEnvironment } from '../utils/env';

export function initializeDatadogRum() {
  datadogRum.init({
    applicationId: '7d763868-eb83-4d5f-9c46-1c2663930f80',
    clientToken: 'pub4792edf2a6f0264df3201eeb9a004426',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: 'portal',
    env: getEnvironment(),
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackBfcacheViews: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      'https://app.kin.com/kin_portal',
      'https://app.kin.insure/kin_portal',
      'https://app.kin.haus/kin_portal',
    ],
  });
}
